module.exports = __webpack_public_path__ + "img/20180815_151629_184.97e3aa77.jpg";